import React from "react";

export default function SQLServer_GETUTCDATE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_GETUTCDATE</h1>
      <p>This is the SQLServer_GETUTCDATE component generated from the SQL JSON.</p>
    </div>
  );
}
